const dateMask = {
	mask: Date,
	pattern: 'd/`m/`Y',
	blocks: {
		d: {
			mask: IMask.MaskedRange,
			from: 1,
			to: 31,
			maxLength: 2,
		},
		m: {
			mask: IMask.MaskedRange,
			from: 1,
			to: 12,
			maxLength: 2,
		},
		Y: {
			mask: IMask.MaskedRange,
			from: 1900,
			to: 2200,
		},
	},
	format: function (date) {
		var day = date.getDate();
		var month = date.getMonth() + 1;
		var year = date.getFullYear();

		if (day < 10) day = '0' + day;
		if (month < 10) month = '0' + month;

		return [day, month, year].join('/');
	},
	parse: function (str) {
		var dayMonthYear = str.split('/');
		return new Date(dayMonthYear[2], dayMonthYear[1] - 1, dayMonthYear[0]);
	},
	min: new Date(1920, 0, 1),
	max: new Date(),
	autofix: false,
	lazy: false,
	overwrite: true,
};

export default dateMask;
